import React from "react";
import TwoColFourStories from "../../../../arrow/components/Rows/TwoColFourStory";
import { object } from "prop-types";

export const ArrowTwoColFourStories = ({ collection }) => {
  const config = {
    buttonText: `${collection.name}`,
  };
  return <TwoColFourStories collection={collection} config={config} />;
};

ArrowTwoColFourStories.propTypes = {
  collection: object,
};

ArrowTwoColFourStories.storyLimit = 4;
